import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "/home",
        component: () => import("@/views/homePage/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/companyList",
        component: () => import("@/views/companyList/index.vue"),
        meta: {
          title: "公司管理",
        },
      },
      {
        path: "/employeeList",
        component: () => import("@/views/employeeList/index.vue"),
        meta: {
          title: "人员管理",
        },
      },
      {
        path: "/permission",
        component: () => import("@/views/permission/index.vue"),
        meta: {
          title: "权限管理",
        },
      },
      {
        path: "/role",
        component: () => import("@/views/role/index.vue"),
        meta: {
          title: "角色管理",
        },
      },
      {
        path: "/taskUsertList",
        component: () => import("@/views/taskUsertList/index.vue"),
        meta: {
          title: "代理人员管理",
        },
      },
      {
        path: "/taskList",
        component: () => import("@/views/taskList/index.vue"),
        meta: {
          title: "任务管理",
        },
      },
      {
        path: "/taskReview",
        component: () => import("@/views/taskReview/index.vue"),
        meta: {
          title: "审核管理",
        },
      },
      {
        path: "/taskData",
        component: () => import("@/views/taskData/index.vue"),
        meta: {
          title: "任务数据",
        },
      },
      {
        path: "/statistionManagement",
        component: () => import("@/views/statistionManagement/index.vue"),
        meta: {
          title: "销冠排行榜",
        },
      },
      {
        path: "/incomeData",
        component: () => import("@/views/incomeData/index.vue"),
        meta: {
          title: "收入看板",
        },
      },
      {
        path: "/withdrawalData",
        component: () => import("@/views/withdrawalData/index.vue"),
        meta: {
          title: "提现看板",
        },
      },
      {
        path: "/commonProblem",
        component: () => import("@/views/commonProblem/index.vue"),
        meta: {
          title: "常见问题",
        },
      },
      {
        path: "/taskUserActivityLevel",
        component: () => import("@/views/taskUserActivityLevel/index.vue"),
        meta: {
          title: "代理人员活跃度",
        },
      },
      {
        path: "/promoter",
        component: () => import("@/views/promoter/index.vue"),
        meta: {
          title: "推广员列表",
        },
      },
    ],
  },
  {
    path: "/dataBoard",
    name: "dataBoard",
    component: () => import("../views/dataBoard/index.vue"),
    meta: {
      title: "数据看板",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path !== "/login" && !localStorage.getItem("userInfo")) {
    next({ path: "/login" });
  } else {
    next();
  }
});
router.afterEach((to) => {
  document.title = to.meta.title;
});

export default router;
